import React from 'react';
import withInit from 'WithInit';
import HeaderIcon from 'HeaderIcon';

const HeaderIconWrapper = () => (
  <HeaderIcon />
  );

export default withInit(HeaderIconWrapper, true);



// WEBPACK FOOTER //
// ./src-react/HeaderIcon/HeaderIconWrapper.jsx